import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { Chart } from '../chart';

const useChartOptions = (categories,chartName) => {
  // const months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  // const chartData = Array(12).fill(0);
  // categories?.forEach(item => {
  //   chartData[item.month - 1] = item.count;
  // });

  const theme = useTheme();

  return {
    chart: {
      background: 'transparent',
      stacked: false,
      toolbar: {
        show: false
      }
    },
    colors: [theme.palette.primary.main, alpha(theme.palette.primary.main, 0.25)],
    dataLabels: {
      enabled: false
    },
    fill: {
      opacity: 1,
      type: 'solid'
    },
    grid: {
      borderColor: theme.palette.divider,
      strokeDashArray: 2,
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      }
    },
    legend: {
      show: false
    },
    plotOptions: {
      bar: {
        columnWidth: '40px'
      }
    },
    stroke: {
      colors: ['transparent'],
      show: true,
      width: 2
    },
    theme: {
      mode: theme.palette.mode
    },
    xaxis: {
      axisBorder: {
        color: theme.palette.divider,
        show: true
      },
      categories:categories,
      axisTicks: {
        color: theme.palette.divider,
        show: true
      },
    
      labels: {
        offsetY: 5,
        style: {
          colors: theme.palette.text.secondary
        }
      }
    },
    yaxis: {
      labels: {
        formatter: (value) => (
          value > 0 && chartName?.value === 'staffingHoursSaved'
            ? `${value} hrs`
            : `${value}`
        ),
        offsetX: -10,
        style: {
          colors: theme.palette.text.secondary
        }
      }
    }
  };
};

export const OverviewSales = (props) => {
  const { chartSeries, sx,chartName } = props;

  const categories = chartSeries.map(item => item.date);
  const data = chartSeries.map(item => item.count);

  const chartOptions = useChartOptions(categories, chartName);

  const series = [
    {
      name: chartName?.label,
      data: data,
    },
  ];

  return (
    <Card sx={sx}>
      <CardHeader
        title={chartName?.label}
      />
      <CardContent>
        <Chart
          height={350}
          options={chartOptions}
          series={series}
          type="bar"
          width="100%"
        />
      </CardContent>
      <Divider />
    </Card>
  );
};

OverviewSales.propTypes = {
  chartSeries: PropTypes.array.isRequired,
  sx: PropTypes.object,
  chartName: PropTypes.object.isRequired
};
